import { axiosClient } from "@/shared/api/axios-client";

/**
 * Snapshot agregado de las solicitudes del usuario actual · todo lo que
 * pinta el dashboard del solicitante. Para Auditor/Admin/MesaDeControl
 * los conteos abarcan la BD completa (lo decide el backend).
 *
 * Diseñado para polling cada 30s · no costoso.
 */
export interface MisEstadisticasDto {
  // 4 KPIs principales
  solicitudesActivas: number;
  requierenMiAccion: number;
  autorizadasUltimos7Dias: number;
  polizasGeneradas: number;

  // Deltas (vs período anterior)
  deltaActivas: number | null;
  deltaAutorizadas: number | null;

  // Insights extra
  proximasAVencer: number;
  enFlujoAutorizacion: number;
  /** Montos en autorización por moneda (v22 · multi-moneda). */
  montosEnAutorizacion: { moneda: string; monto: number }[];

  // Distribución por resultado (últimos 3 meses) · 8 buckets MECE
  distribucion: DistribucionEstadosDto;

  /**
   * Qué dashboard servir · el backend lo determina por rol:
   *   - "Autorizador" · KPIs hablan de su bandeja de autorización
   *   - "Admin" · KPIs agregados de toda la BD (Auditor/Admin/MesaDeControl)
   *   - "Visor" · KPIs globales de solo lectura (labels de panorama)
   *   - "Solicitante" (default) · KPIs de sus propias solicitudes
   */
  audiencia: "Solicitante" | "Autorizador" | "Admin" | "Visor";
}

export interface DistribucionEstadosDto {
  enProceso: number;
  enAutorizacion: number;
  autorizadas: number;
  canceladasPorSolicitante: number;
  rechazadasPorReglas: number;
  rechazadasPorSat: number;
  dadasDeBajaMesaControl: number;
  descartadasPlazoVencido: number;
}

export async function obtenerMisEstadisticas(): Promise<MisEstadisticasDto> {
  const { data } = await axiosClient.get<MisEstadisticasDto>(
    "/api/solicitudes/mis-estadisticas",
  );
  return data;
}
